import React from "react";
import AgreementServices from "./AgreementServices";

const ServicesTab = ({
  agreementPublicId,
  services,
  setServices,
  setHasChanges,
}) => {
  return (
    <AgreementServices
      agreementPublicId={agreementPublicId}
      services={services}
      setServices={setServices}
      setHasChanges={setHasChanges}
    />
  );
};

export default ServicesTab;
